<template>
  <layout>
    <v-container fluid pt-0 mt-0 pb-0 class="white">
      <Document />
    </v-container>
  </layout>
</template>

<script>
import Document from "../components/documentation/MainDocumentation"
import HomeLayout from '../layouts/HomeLayout.vue'


export default {
  name: 'Documentation',
  components: { Document, layout: HomeLayout },
  metaInfo: { title: "Facilita Pay" }
}

</script>



// WEBPACK FOOTER //
// src/pages/StaticDocumentation.vue